import { useSelector } from "react-redux";
import type { ExportChartFormats } from "../../viewer/chart/ChartProps.ts";
import type { ChartGridState } from "../../viewer/chart/hooks/gridState.types.ts";
import PreviewComponent from "../../viewer/chart/PreviewComponent.tsx";
import { selectPreviewMode } from "../../../store/selectors/currentReportSelectors";
import { selectArguments, selectValues } from "../../../store/selectors/fieldsStateSelectors";
import useCommonReportHandlers from "../common/hooks/useCommonReportHandlers.ts";
import type { ChartStyleSettings, ReportType } from "../../../../../../../api/types/svTypes.ts";

interface Props {
  state: ChartGridState;
  reportType: ReportType | undefined;
  settings: ChartStyleSettings;
  exportFuncCallback?: (callback: ((fileName: string, format: ExportChartFormats) => void) | undefined) => void;
}
const EditPreviewComponent = ({ state, reportType, settings, exportFuncCallback }: Props) => {
  const argumentFields = useSelector(selectArguments);
  const values = useSelector(selectValues);
  const handlers = useCommonReportHandlers(values);
  const previewMode = useSelector(selectPreviewMode);

  return (
    <PreviewComponent
      state={state}
      argumentFields={argumentFields}
      values={values}
      reportType={reportType}
      settings={settings}
      exportFuncCallback={exportFuncCallback}
      onDrillDown={handlers.onDrillDown}
      previewMode={previewMode}
    />
  );
};

export default EditPreviewComponent;
